var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { hexToRgba } from "../../helpers";
var Separator = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    z-index: 3;\n    border-color: ", ";\n    border-width: 0;\n    flex-shrink: 0;\n\n    ", "\n"], ["\n    z-index: 3;\n    border-color: ", ";\n    border-width: 0;\n    flex-shrink: 0;\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorBorderMain;
}, function (_a) {
    var isRow = _a.isRow;
    return isRow
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                  width: 0;\n                  border-right-style: solid;\n                  border-right-width: 1px;\n              "], ["\n                  width: 0;\n                  border-right-style: solid;\n                  border-right-width: 1px;\n              "]))) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                  height: 0;\n                  border-top-style: solid;\n                  border-top-width: 1px;\n              "], ["\n                  height: 0;\n                  border-top-style: solid;\n                  border-top-width: 1px;\n              "])));
});
var Draggable = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 2;\n    transition: background-color 0.25s ease;\n    display: flex;\n    flex-direction: ", ";\n    align-items: stretch;\n    justify-content: center;\n\n    ", "\n\n    &:hover {\n        ", "\n    }\n\n    ", "\n\n    ", "\n"], ["\n    position: absolute;\n    z-index: 2;\n    transition: background-color 0.25s ease;\n    display: flex;\n    flex-direction: ", ";\n    align-items: stretch;\n    justify-content: center;\n\n    ",
    "\n\n    &:hover {\n        ",
    "\n    }\n\n    ",
    "\n\n    ",
    "\n"])), function (_a) {
    var isRow = _a.isRow;
    return (isRow ? 'row' : 'column');
}, function (_a) {
    var theme = _a.theme;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: rgba(", ");\n    "], ["\n        background-color: rgba(", ");\n    "])), hexToRgba(theme.colorBorderMain, 0).join(','));
}, function (_a) {
    var resizable = _a.resizable, theme = _a.theme;
    return resizable && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                background-color: rgba(", ");\n            "], ["\n                background-color: rgba(", ");\n            "])), hexToRgba(theme.colorBorderMain, 0.5).join(','));
}, function (_a) {
    var isRow = _a.isRow;
    return isRow
        ? css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                  top: 0;\n                  left: -5px;\n                  bottom: 0;\n                  right: -5px;\n              "], ["\n                  top: 0;\n                  left: -5px;\n                  bottom: 0;\n                  right: -5px;\n              "]))) : css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                  top: -5px;\n                  left: 0;\n                  bottom: -5px;\n                  right: 0;\n              "], ["\n                  top: -5px;\n                  left: 0;\n                  bottom: -5px;\n                  right: 0;\n              "])));
}, function (_a) {
    var resizable = _a.resizable, isRow = _a.isRow;
    return resizable && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            &:hover {\n                cursor: ", ";\n            }\n        "], ["\n            &:hover {\n                cursor: ", ";\n            }\n        "])), isRow ? 'col-resize' : 'row-resize');
});
var ResizeableRoot = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: relative;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: ", ";\n    align-content: stretch;\n    z-index: 2;\n\n    ", "\n"], ["\n    position: relative;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: ", ";\n    align-content: stretch;\n    z-index: 2;\n\n    ",
    "\n"])), function (_a) {
    var isRow = _a.isRow;
    return (isRow ? 'row' : 'column');
}, function (_a) {
    var isRow = _a.isRow;
    return isRow
        ? css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                  width: 0;\n              "], ["\n                  width: 0;\n              "]))) : css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n                  height: 0;\n              "], ["\n                  height: 0;\n              "])));
});
export function SplitSeparator(_a) {
    var _b = _a.isRow, isRow = _b === void 0 ? true : _b, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onMouseMove = _a.onMouseMove, resizable = _a.resizable;
    var tearDownRef = useRef(null);
    var startMove = function (e) {
        var _a;
        (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        if (e.button !== 0) {
            return;
        }
        var x = e.clientX, y = e.clientY;
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(x, y);
        var stop = function (e) {
            var _a;
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(e.clientX, e.clientY);
            (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
            tearDownRef.current = null;
        };
        var mouseMoveHandler = function (e) {
            requestAnimationFrame(function () {
                var _a, _b, _c, _d;
                try {
                    (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty) === null || _b === void 0 ? void 0 : _b.call(_a);
                    (_d = (_c = window.getSelection()) === null || _c === void 0 ? void 0 : _c.removeAllRanges) === null || _d === void 0 ? void 0 : _d.call(_c);
                }
                catch (_e) { }
                onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(e.clientX, e.clientY);
            });
        };
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('contextmenu', stop);
        document.addEventListener('mouseup', stop);
        document.addEventListener('mousedown', stop);
        document.addEventListener('mouseleave', stop);
        document.addEventListener('keydown', stop);
        document.addEventListener('blur', stop);
        tearDownRef.current = function () {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('contextmenu', stop);
            document.removeEventListener('mousedown', stop);
            document.removeEventListener('mouseup', stop);
            document.removeEventListener('mouseleave', stop);
            document.removeEventListener('keydown', stop);
            document.removeEventListener('blur', stop);
        };
    };
    useEffect(function () {
        return function () {
            var _a;
            (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        };
    }, []);
    return (React.createElement(ResizeableRoot, { isRow: isRow, "data-selector-id": 'split-separator' },
        React.createElement(Draggable, { resizable: resizable, onMouseDown: function (e) { return resizable && startMove(e); }, isRow: isRow },
            React.createElement(Separator, { isRow: isRow }))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=SplitSeparator.js.map